import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const planService = {
  getPlanTypesList: () =>
    axiosInstance.get(endpoints.tokenEndPoints.getAllPlanTypes),
  getPlanDetails: (id) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.planDetails}/${id}`),
  updatePlan: (id, data) =>
    axiosInstance.patch(`${endpoints.tokenEndPoints.updatePlan}/${id}`, data),
  addPlan: (data) =>
    axiosInstance.post(endpoints.tokenEndPoints.addPlan, data),
  deletePlan: (id) =>
    axiosInstance.delete(`${endpoints.tokenEndPoints.deletePlan}/${id}`),
};
